import { render, staticRenderFns } from "./GroupSelectModal.vue?vue&type=template&id=c2ca8d96&lang=pug"
import script from "./GroupSelectModal.vue?vue&type=script&lang=ts"
export * from "./GroupSelectModal.vue?vue&type=script&lang=ts"
import style0 from "./GroupSelectModal.vue?vue&type=style&index=0&id=c2ca8d96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports